// API服务类 - 处理与后端的通信
export interface ConsultationFormData {
  name: string;
  phone?: string;
  email?: string;
  wechat?: string;
  companyName: string;
  businessRequirements?: string;
}

export interface ApiResponse<T = any> {
  code: number;
  message: string;
  data?: T;
  timestamp: number;
}

export interface ConsultationResponse {
  id: number;
  name: string;
  phone?: string;
  email?: string;
  wechat?: string;
  companyName: string;
  businessRequirements?: string;
  createdAt: string;
  updatedAt: string;
}

class ApiService {
  private baseURL: string;

  constructor() {
    // 根据环境设置API基础URL
    // 开发环境明确指向后端API服务器
    if (process.env.NODE_ENV === 'development' || !process.env.NODE_ENV) {
      this.baseURL = 'http://localhost:8080/api'; // 修改为相对路径
    } else {
      // 生产环境使用相对路径
      this.baseURL = 'http://www.auditai.com.cn:8080/api';
    }
    
    // 调试信息
    console.log('Current NODE_ENV:', process.env.NODE_ENV);
    console.log('API Service initialized with baseURL:', this.baseURL);
  }

  // 通用请求方法
  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
    const url = `${this.baseURL}${endpoint}`;
    
    const headers = {
      'Content-Type': 'application/json', // 添加JSON内容类型头
      ...(options.headers || {}),
    };
    
    const config: RequestInit = {
      ...options,
      headers,
    };
    
    try {
      const response = await fetch(url, config);
      
      // 检查HTTP状态码
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ApiResponse<T> = await response.json();
      
      // 检查业务状态码
      if (data.code !== 200) {
        throw new Error(data.message || '请求失败');
      }

      return data;
    } catch (error) {
      // 网络错误或其他异常
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('网络请求失败，请检查网络连接');
    }
  }

  // 提交咨询表单
  async submitConsultation(formData: ConsultationFormData): Promise<ApiResponse<ConsultationResponse>> {
    return this.request<ConsultationResponse>('/consultation/submit', {
      method: 'POST',
      body: JSON.stringify(formData),
    });
  }

  // 健康检查
  async checkHealth(): Promise<ApiResponse<string>> {
    return this.request<string>('/consultation/health');
  }

  // 获取咨询列表（管理功能，可选）
  async getConsultations(page: number = 0, size: number = 10): Promise<ApiResponse<any>> {
    return this.request(`/consultation/list?page=${page}&size=${size}`);
  }

  // 根据ID获取咨询详情（管理功能，可选）
  async getConsultationById(id: number): Promise<ApiResponse<ConsultationResponse>> {
    return this.request<ConsultationResponse>(`/consultation/${id}`);
  }
}

// 创建单例实例
const apiService = new ApiService();

export default apiService; 